export default "__VITE_ASSET__7b6d89ad__"